<template>
    <div>
        <Button @click="additem">{{
            $t("global.common.operation_add", { defaultValue: "添加" })
        }}</Button>
        <Table
            class="margin-top-20"
            :loading="loading"
            :columns="columns"
            :data="datalist"
            size="small"
            ref="table"
            border
        ></Table>
        <!-- <div class="color-error">{{$t('erp.b2c.forcemanual_notes',{defaultValue:'注意：如果ERP SKU、发货数量不填，默认整个订单只有一个包裹。'})}}</div> -->
        <Form :label-width="150" inline class="margin-top-15">
            <FormItem
                :label="
                    $t('erp.b2c.delivery_warehouse', {
                        defaultValue: '发货仓库',
                    })
                "
                style="width: 50%; margin: auto"
            >
                <Select v-model="orgWarehouseId" filterable>
                    <Option
                        v-for="item in orgWarehouseAll"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
                <!-- <span class="color-error">{{$t('erp.b2c.forcemanual_warning',{defaultValue:'订单需要获取成本的话，发货仓库必填'})}}</span> -->
            </FormItem>
            <div
                style="margin-left: 90px; margin-top: 20px"
                class="color-error"
            >
                <div>
                    {{
                        $t("erp.b2c.order_attention", { defaultValue: "注意" })
                    }}：
                </div>
                <div>
                    1.{{
                        $t("erp.b2c.order_manualback_tip_1", {
                            defaultValue:
                                "如果ERP SKU、发货数量不填，默认整个订单只有一个包裹",
                        })
                    }}；
                </div>
                <div>
                    2.{{
                        $t("erp.b2c.order.manualback_tip_2", {
                            defaultValue: "订单需要获取成本的话，发货仓库必填",
                        })
                    }}；
                </div>
                <div>
                    3.{{
                        $t("erp.b2c.order.manualback_tip_3", {
                            defaultValue:
                                "虚拟回传不会改变关联的配货单状态，配货单需要单独操作完成",
                        })
                    }}。
                </div>
            </div>
        </Form>
        <footer class="text-right margin-top-10">
            <Button type="primary" @click="clickModal">{{
                $t("erp.b2c.return", { defaultValue: "回传" })
            }}</Button>
            <Button class="margin-left-10" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>

        <!-- 弹框 -->
        <Modal
            v-model="operate.show"
            width="360"
            @on-cancel="close('all')"
            :key="operate.index + 1"
        >
            <div slot="header" style="color: #f60; text-align: center">
                <p>{{ operate.title }}</p>
            </div>
            <div style="text-align: center">
                <p>{{ operate.content }}</p>
            </div>
            <div slot="footer">
                <Button
                    type="error"
                    size="large"
                    :loading="showDel"
                    long
                    @click="submit"
                    >{{
                        $t("global.common.update_OK", { defaultValue: "确定" })
                    }}</Button
                >
            </div>
        </Modal>

        <Spin size="large" fix v-if="formloading"></Spin>
    </div>
</template>
<script>
import {
    HttpqueryB2COrder,
    HttpVsSkuList,
    HttpforceTrackingReturn,
    HttpFindWarehouseCarriers,
} from "@/service/boss/b2corder";
import { HttpPlatformSystem } from "@/service/managechannel/managechannel";
import { HttpGetAllCustomerIdCode } from "@/service/boss/b2corder";
import { mapState, mapGetters } from "vuex";

export default {
    props: ["activeids", "nodeid", "warehouseid", "orgId"],
    data() {
        return {
            formloading: false,
            loading: false,
            id: this.$route.query.id,
            // issuper: this.$route.query.issuper == 1,
            // nodeid:this.$route.query.nodeid,
            datalist: [],
            volumeTypes: [],
            nowdate: "",
            judge: false,
            operate: {
                // loading:true,
                show: false,
                title: "",
                content: "",
                oktext: this.$t("global.common.update_OK", {
                    defaultValue: "确定",
                }),
                canceltext: this.$t("global.common.operation_cancel", {
                    defaultValue: "取消",
                }),
                index: 1,
            },
            orgWarehouseId: "",
            showDel: false,
        };
    },
    computed: {
        ...mapGetters("dictionary", ["getNewAllWarehouseIdList"]),
        orgWarehouseAll() {
            let _this = this;
            return this.getNewAllWarehouseIdList.filter(function (item) {
                return (
                    item.attach.orgId == _this.orgId &&
                    item.attach.warehouseType != 4
                );
            });
        },

        columns() {
            const _this = this;
            return [
                {
                    // title: 'Tracking NO',
                    key: "trackingNo",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "Tracking NO"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    size: "small",
                                    value: row.trackingNo,
                                },
                                on: {
                                    input: (event) => {
                                        row.trackingNo = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.trackingNo}</div>;
                        }
                    },
                },
                {
                    // title: '',
                    key: "carrier",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "Carrier"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h(
                                "Select",
                                {
                                    props: {
                                        value: _this.datalist[index].carrier,
                                        filterable: true,
                                        clearable: true,
                                    },
                                    on: {
                                        "on-change": (value) => {
                                            _this.datalist[index].carrier =
                                                value;
                                        },
                                    },
                                },
                                _this.volumeTypes.map((json) => {
                                    // console.log(json)
                                    return h("Option", {
                                        props: json,
                                    });
                                })
                            );
                        } else {
                            return <div>{row.carrier}</div>;
                        }
                    },
                },
                {
                    title: "ERP SKU",
                    key: "erpSku",
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    size: "small",
                                    value: row.erpSku,
                                },
                                on: {
                                    input: (event) => {
                                        row.erpSku = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.erpSku}</div>;
                        }
                    },
                },
                {
                    title: this.$t("erp.b2c.quantity_shipped", {
                        defaultValue: "发货数量",
                    }),
                    key: "shipedQuantity",
                    width: 120,
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("InputNumber", {
                                props: {
                                    size: "small",
                                    min: 1,
                                    value: row.shipedQuantity,
                                },
                                on: {
                                    input: (event) => {
                                        row.shipedQuantity = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.shipedQuantity}</div>;
                        }
                    },
                },
                {
                    title: "Shipping Cost",
                    key: "cost",
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    size: "small",
                                    value: row.cost,
                                },
                                on: {
                                    input: (event) => {
                                        row.cost = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.cost}</div>;
                        }
                    },
                },
                {
                    // title: '',
                    key: "shipmentDate",
                    width: 220,
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t("erp.b2c.search_outtime", {
                                    defaultValue: "发货时间",
                                })
                            ),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("DatePicker", {
                                props: {
                                    type: "datetime",
                                    placeholder: "Select date",
                                    value: _this.datalist[index].shipmentDate,
                                },
                                on: {
                                    "on-change": function (date) {
                                        // console.log(date)
                                        _this.datalist[index].shipmentDate =
                                            date;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.shipmentDate}</div>;
                        }
                    },
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    width: 140,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    style: {
                                        marginRight: "5px",
                                    },
                                    on: {
                                        click: () => {
                                            _this.changeEdit(row);
                                        },
                                    },
                                },
                                _this.$t("global.common.operation_edit", {
                                    defaultValue: "编辑",
                                })
                            ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.comremove(index);
                                        },
                                    },
                                },
                                _this.$t("global.common.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    created() {
        this.getNowFormatDate();
        this.getpackages();

        // alert(1)
    },
    methods: {
        // 点击出弹框
        clickModal() {
            // console.log(112345)
            this.operate.show = true;
            this.operate.title = this.$t("erp.b2c.mandatorymanual_back", {
                defaultValue: "强制手动回传",
            });
            this.operate.content = this.$t("erp.b2c.mandatorymanual_desc", {
                defaultValue:
                    "确定强制手动回传？强制手动回传会直接将Tracking信息回传，不会推送到仓库！",
            });
            // this.operate = {
            //     show:true,
            //     title: '',
            //     content: "订单重置后会恢复初始状态，并变为手工订单，是否确认提交？",
            //     // type:val,
            // }
        },
        getNowFormatDate() {
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
            this.nowdate = currentdate;
            // console.log(this.nowdate)
        },
        getpackages() {
            let _this = this;
            this.loading = true;
            this.orgWarehouseId = this.warehouseid;
            HttpqueryB2COrder({
                orderId: this.activeids,
                node: this.nodeid,
                // contextId: 1
            }).then(
                (res) => {
                    // console.log(res.data)
                    let resdata = res.data.packages;
                    if (resdata == null) {
                        resdata = [];
                    } else {
                        resdata.map((item) => {
                            item.$Edit = false;
                        });
                    }
                    // if(!res.data.logistics.orgWarehouseCode){
                    //     this.$Message.error('未分配仓库，发货方式不存在');
                    // }else{
                    // _this.formloading = true;
                    // HttpPlatformSystem({
                    //     page: 1,
                    //     rows: 500,
                    //     sidx: 'id',
                    //     sord: 'desc',
                    //     // orderType:200
                    // }).then(res=>{
                    //     let array = res.data.content.map(item=>{
                    //         return item.carrierServiceCode
                    //     })
                    //     array = array.sort(function(a,b){
                    //         return a.localeCompare(b)
                    //     })
                    //     _this.volumeTypes = Array.from(new Set(array))
                    // })
                    HttpGetAllCustomerIdCode().then(
                        (res) => {
                            let array = res.data.map((item) => {
                                // return item.carrierServiceCode
                                return {
                                    value: item.code,
                                    label: `${item.code}(${item.carrierServiceName})`,
                                };
                            });
                            array = array.sort(function (a, b) {
                                return a.value.localeCompare(b.value);
                            });
                            _this.volumeTypes = Array.from(new Set(array));
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    );
                    // }

                    let filterarr =
                        resdata.filter((item) => {
                            return item.packageFlag == 1;
                        }) || [];
                    if (filterarr.length < 1) {
                        this.datalist = resdata || [];
                    } else {
                        this.datalist = filterarr || [];
                    }

                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.errorMessage(err.message);
                }
            );
        },
        additem() {
            let _this = this;
            let itemdata = {
                trackingNo: null,
                carrier: null,
                erpSku: null,
                cost: null,
                shipedQuantity: null,
                shipmentDate: _this.nowdate + " 18:00:00",
                $Edit: true,
            };
            this.datalist.push(itemdata);
            // console.log(this.datalist)
        },
        changeEdit(row) {
            this.$set(row, "$Edit", true);
        },
        cancel() {
            this.$emit("on-close");
        },
        close() {
            this.$emit("on-close");
        },
        submit() {
            if (this.datalist.length < 1) {
                this.$Message.error(
                    this.$t("erp.b2c.leastone_returndata", {
                        defaultValue: "请填写至少一条回传数据",
                    })
                );
                return;
            }
            this.loading = true;
            this.showDel = true;
            HttpforceTrackingReturn({
                orderId: this.activeids,
                orgWarehouseId: this.orgWarehouseId,
                contextId: this.orgId,
                packages: this.datalist,
            }).then(
                (res) => {
                    this.loading = false;
                    this.showDel = false;
                    this.$Message.success(res.message);
                    this.$emit("on-update");
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.showDel = false;
                    this.errorMessage(err.message);
                }
            );
        },
        comremove(index) {
            this.datalist.splice(index, 1);
        },
    },
};
</script>
